import React, { Component } from 'react';

import JobDetailsView from './JobDetailsView';
import { url } from '../../Server/url/GlobalUrl';
import moment from 'moment';

class JobDetailsComponent extends Component {
  state = {
    modal_show: false,
    job_detail: '',
    modal_show_custom: false,
    authResponse: '',
    user: '',
    applied: false,
    shift_strings: [],
    wishlist_data: [],
    qualification_id: [],
    redirect_reg: false,
    qualification_data: [],
    apply_job_check: false,
    apply_modal_show: false,
    applied_job_id: '',
    applied_shift_id: [],
    shift_select_timing: [],
    total_shift: 0,
    today_date: moment(new Date()).format('YYYY-MM-DD'),
    closing_job_date: '',
  };

  handelShift = (id, checked) => {
    console.log('shift  id', id, checked);
    if (id === 'all') {
      if (checked) {
        var i;
        for (i = 0; i < this.state.shift_select_timing.length; i++) {
          this.state.applied_shift_id.push(
            this.state.shift_select_timing[i].shift_id
          );
          this.setState({ applied_shift_id: this.state.applied_shift_id });
        }
        console.log('this.state.applied_shift_id', this.state.applied_shift_id);
      } else {
        this.state.applied_shift_id.splice(
          0,
          this.state.applied_shift_id.length
        );
        this.setState({ applied_shift_id: this.state.applied_shift_id });
        console.log('this.state.applied_shift_id', this.state.applied_shift_id);
      }
    } else {
      if (checked) {
        this.state.applied_shift_id.push(id);
        this.setState({ applied_shift_id: this.state.applied_shift_id });
      } else {
        var index = this.state.applied_shift_id
          .map((x) => {
            return x.Id;
          })
          .indexOf(id);
        console.log('id', id);
        this.state.applied_shift_id.splice(index, 1);
        this.setState({ applied_shift_id: this.state.applied_shift_id });
      }
    }
    console.log('this.state.applied_shift_id', this.state.applied_shift_id);
  };

  applyHideCustomModal = () => {
    this.setState({ apply_modal_show: false });
  };

  applyShowCustomModal = (id) => {
    this.setState({ apply_job_check: true });
    console.log('id', id);
    if (localStorage.getItem('token')) {
      let auth = localStorage.getItem('token');
      fetch(url + '/jobs/job-shifts/?job_id=' + id, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth,
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            console.log('result-showCustomModal', result);
            this.setState({ shift_select_timing: result, applied_job_id: id });
            this.setState({ apply_modal_show: true });
          },
          (error) => {
            console.log('error', error);
          }
        );
    } else {
      window.location.replace('/login');
    }
  };

  applyShowCustomModalFavorite = (id) => {
    this.setState({ apply_job_check: false });
    console.log('id', id);
    if (localStorage.getItem('token')) {
      let auth = localStorage.getItem('token');
      fetch(url + '/jobs/job-shiftswl/?job_id=' + id, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth,
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            console.log('resulT', result);

            this.setState({ shift_select_timing: result, applied_job_id: id });
            this.setState({ apply_modal_show: true });
          },
          (error) => {
            console.log('error', error);
          }
        );
    } else {
      window.location.replace('/login');
    }
  };

  hideCustomModal = () => {
    this.setState({ modal_show_custom: false });
    if (this.state.redirect_reg) {
      window.location.replace('/registration/submit-cv');
    }
  };

  showCustomModal = () => {
    this.setState({ modal_show_custom: true });
  };
  //   addToFavourites = (id) =>{
  //     console.log(id);
  //     let auth = localStorage.getItem("token");
  //     // let user = localStorage.getItem("cv-id");
  //     fetch(url + "/jobs/wishlist/" ,{
  //     method:"POST",
  //     headers: {
  //         'Accept': "application/json",
  //         'Content-Type': "application/json",
  //         'Authorization': 'Bearer ' + auth,

  //     },
  //     body:JSON.stringify({"job_post": id})
  //     })
  //     .then((response) => {
  //         // console.log("Response", response.json())
  //         return response.json()

  //         // console.log(this.state.data);
  //         if(response['status'] === 201 || response['status'] === 200){
  //             this.showCustomModal()
  //             this.setState({authResponse:"Added to the favourites"});
  //         }
  //     })
  //         .then((data) =>{
  //             this.showCustomModal()
  //             this.setState({authResponse:"Added to the favourites"});
  //             this.get_wishlist_data();
  //             console.log(data);
  //         })

  //           .catch((err) => {
  //              this.showCustomModal()
  //             this.setState({authResponse:"Error While Adding to favourites"});
  //             console.log("ERROR",err.body);
  //         })
  //      }

  applyfavorite = async () => {
    let id = this.state.applied_job_id;
    this.applyHideCustomModal();
    console.log('shift id', this.state.applied_shift_id);
    console.log('job id', this.state.applied_job_id);
    if (localStorage.getItem('token')) {
      var i;
      for (i = 0; i < this.state.applied_shift_id.length; i++) {
        let data = {
          job_post: this.state.applied_job_id,
          shift: this.state.applied_shift_id[i],
        };
        console.log('data', data);
        let auth = localStorage.getItem('token');
        await fetch(url + '/jobs/wishlist/', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + auth,
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            console.log('response', response);
            if (response['status'] === 201 || response['status'] === 200) {
              this.showCustomModal();
              this.setState({
                authResponse: 'Job Is Added to the favourites successfully ',
              });
              return response.json();
            } else if (
              response['status'] === 400 ||
              response['status'] === 401
            ) {
              this.showCustomModal();
              this.setState({
                authResponse: 'Some thing went wrong please try again ',
              });
            } else if (response['status'] === 406) {
              this.showCustomModal();
            }
            return response.json();
          })
          .then((result) => {
            if (result.error) {
              this.setState({ authResponse: result.error });
            }
            console.log('result', result);
          });
      }
      this.state.applied_shift_id.splice(0, this.state.applied_shift_id.length);
      this.setState({ applied_shift_id: this.state.applied_shift_id });
      this.get_string_shift_data();
    } else {
      window.location.replace('/login');
    }
  };

  applyjob = async () => {
    let id = this.state.applied_job_id;
    this.applyHideCustomModal();
    console.log('shift id', this.state.applied_shift_id);
    console.log('job id', this.state.applied_job_id);
    if (localStorage.getItem('token')) {
      var i;
      for (i = 0; i < this.state.applied_shift_id.length; i++) {
        let data = {
          job: this.state.applied_job_id,
          shift: this.state.applied_shift_id[i],
        };
        let auth = localStorage.getItem('token');
        await fetch(url + '/jobs/user-applied-jobs/', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + auth,
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            console.log('response', response);
            if (response['status'] === 201 || response['status'] === 200) {
              this.showCustomModal();
              this.setState({
                authResponse: 'You Have applied to job successfully ',
              });
              return response.json();
            } else if (
              response['status'] === 400 ||
              response['status'] === 401
            ) {
              this.showCustomModal();
              this.setState({
                authResponse: 'Some thing went wrong please try again ',
              });
            } else if (response['status'] == 406) {
              this.showCustomModal();
            }
            return response.json();
          })
          .then((result) => {
            console.log('resulT', result);
            if (result.error == 'You are not assigned a role of candidate') {
              this.setState({ redirect_reg: true });
            }
            this.setState({ authResponse: result.error });
          });
      }
      this.state.applied_shift_id.splice(0, this.state.applied_shift_id.length);
      this.setState({ applied_shift_id: this.state.applied_shift_id });
      this.get_string_shift_data();
    } else {
      window.location.replace('/login');
    }
  };

  tConvert(time) {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      console.log('helllio', time);
      time.splice(-1, 1);
    }
    return time.join(''); // return adjusted time or original string
  }

  // get_wishlist_data = () => {
  //     let auth = localStorage.getItem("token");
  //      let user = localStorage.getItem("cv-id");
  //      fetch(url + "/jobs/wishlist/?user="+user ,{
  //      method:"GET",
  //      headers: {
  //          'Accept': "application/json",
  //          'Content-Type': "application/json",
  //          'Authorization': 'Bearer ' + auth,

  //      },
  //      })
  //      .then((response) => {
  //          // console.log("Response", response.json())
  //          return response.json()

  //          // console.log(this.state.data);
  //          if(response['status'] === 201 || response['status'] === 200){
  //              // this.showCustomModal()
  //              // this.setState({authResponse:"Added to the favourites"});
  //          }
  //      })
  //          .then((data) =>{
  //              // this.showCustomModal()
  //              // this.setState({authResponse:"Added to the favourites"});
  //              console.log("DATA");
  //              this.setState({wishlist_data: data})
  //              console.log(data)

  //          })

  //            .catch((err) => {
  //               this.showCustomModal()
  //              this.setState({authResponse:"Error While Adding to favourites"});
  //              console.log("ERROR",err.body);
  //          })

  //  }

  componentDidMount() {
    const uri = window.location.href.split('/').pop();
    console.log('pawas', uri);
    if (uri === '#applied') {
      this.setState({ applied: true });
    }
    let data_refresh = { refresh: localStorage.getItem('refresh') };
    fetch(url + '/api/token/refresh/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data_refresh),
    })
      .then((response) => {
        if (response['status'] === 201 || response['status'] === 200) {
          return response.json();
        } else if (response['status'] === 401) {
          this.showCustomModal();
          this.setState({ authResponse: 'Some Thing went wrong' });
        }
      })
      .then((result) => {
        if (result) {
          console.log('result.access', result.access);
          localStorage.setItem('token', result.access);
        }
      });
    console.log('this.props.match.params.id', this.props.match.params.id);

    fetch(url + '/jobs/qualification/', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ qualification_data: result });
        },
        (er) => {
          console.log('ERROR ON QUALIFICATION', er);
        }
      );

    let auth = localStorage.getItem('token');
    fetch(url + '/jobs/job-post/' + this.props.match.params.id + '/', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + auth,
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.detail === 'Given token not valid for any token type') {
            this.setState({ job_detail: [] });
            console.log('result', result);
            localStorage.removeItem('token');
            localStorage.removeItem('refresh');
            localStorage.removeItem('is_applicant');
            localStorage.removeItem('is_admin');
            localStorage.removeItem('is_candidate');
            localStorage.removeItem('is_pre_screen_applicant');
          } else {
            if (result) {
              console.log(result);
              if (
                result.start_date_arrival_time ||
                result.start_date_departure_time ||
                result.end_date_arrival_time ||
                result.end_date_departure_time
              ) {
                if (result.start_date_arrival_time) {
                  var start_date_arrival_time = this.tConvert(
                    result.start_date_arrival_time
                  );
                  result['start_date_arrival_time'] = start_date_arrival_time;
                }
                if (result.start_date_departure_time) {
                  var start_date_departure_time = this.tConvert(
                    result.start_date_departure_time
                  );
                  result['start_date_departure_time'] =
                    start_date_departure_time;
                }
                if (result.end_date_arrival_time) {
                  var end_date_arrival_time = this.tConvert(
                    result.end_date_arrival_time
                  );
                  result['end_date_arrival_time'] = end_date_arrival_time;
                }
                if (result.end_date_departure_time) {
                  var end_date_departure_time = this.tConvert(
                    result.end_date_departure_time
                  );
                  result['end_date_departure_time'] = end_date_departure_time;
                }
              }
              if (result.start_date) {
                var day = moment(result.start_date).format('dddd DD/MM');
                result['start_shift'] =
                  day +
                  ' from ' +
                  start_date_arrival_time +
                  ' to ' +
                  start_date_departure_time;
              }
              if (result.end_date) {
                var day = moment(result.end_date).format('dddd DD/MM');
                result['end_shift'] =
                  day +
                  ' from ' +
                  end_date_arrival_time +
                  ' to ' +
                  end_date_departure_time;
              }
              if (result.qualification) {
                var k = '';
                var j;
                var r = '';
                // console.log(JSON.parse(result.qualification));
                console.log(result.qualification);
                this.setState({ qualification_id: result.qualification });
                var qualification_string_data = [];
                for (var each of this.state.qualification_data) {
                  for (var data of this.state.qualification_id) {
                    console.log(data, each);
                    if (data == each.id) {
                      qualification_string_data.push(each.type);
                    }
                  }
                }
                console.log(qualification_string_data);
                this.setState({
                  qualification: qualification_string_data.join(','),
                });
              }
              if (result.close_date) {
                var day = moment(result.close_date).format('MMMM DD/YYYY');
                this.setState({
                  closing_job_date: moment(result.close_date).format(
                    'YYYY-MM-DD'
                  ),
                });
                result['close_date'] = day;
              }
              console.log('result.shifts', result.shifts);
              if (result.shifts && result.shifts.length > 0) {
                var j;
                for (j of result.shifts) {
                  console.log('shifts.length', j);

                  if (j.start_carer_type === 1 || j.start_carer_type === 3) {
                    var index = result.shifts.indexOf(j);
                    console.log('index', index);
                    if (index != 0) {
                      console.log(
                        'result.shifts[index-1]',
                        result.shifts[index - 1].start_repeate
                      );
                      var repeate = result.shifts[index - 1].start_repeate;
                    } else {
                      var repeate = result.shifts[index].start_repeate;
                    }
                    if (j.start_repeate == repeate) {
                      var start_string =
                        j.start_quantity +
                        1 +
                        ' Carer' +
                        ' ' +
                        j.start_repeate +
                        ' begins ' +
                        j.start_date +
                        ' from ' +
                        j.start_date_arrival_time +
                        ' to ' +
                        j.start_date_departure_time;
                      var end_string =
                        j.end_quantity +
                        1 +
                        ' Carer' +
                        ' ' +
                        j.end_repeate +
                        ' begins ' +
                        j.end_date +
                        ' from ' +
                        j.end_date_arrival_time +
                        ' to ' +
                        j.end_date_departure_time;
                    }
                  } else {
                    var index = result.shifts.indexOf(j);
                    console.log('indexasd', index);
                    if (index != 0) {
                      console.log(
                        'result.shifts[index-1]',
                        result.shifts[index - 1].start_repeate
                      );
                      var start_date = result.shifts[index - 1].start_date;
                    } else {
                      var start_date = result.shifts[index].start_date;
                    }
                    if (j.start_date == start_date) {
                      console.log('indexasd1', index);
                      var start_string =
                        j.start_quantity +
                        1 +
                        ' Nurses' +
                        ' ' +
                        j.start_repeate +
                        ' begins ' +
                        j.start_date +
                        ' from ' +
                        j.start_date_arrival_time +
                        ' to ' +
                        j.start_date_departure_time;
                      var end_string =
                        j.end_quantity +
                        1 +
                        ' Nurses' +
                        ' ' +
                        j.end_repeate +
                        ' begins ' +
                        j.end_date +
                        ' from ' +
                        j.end_date_arrival_time +
                        ' to ' +
                        j.end_date_departure_time;
                    }
                    j['start_string'] = start_string;
                    j['end_string'] = end_string;
                  }
                  j['start_string'] = start_string;
                  j['end_string'] = end_string;
                }
              }
              this.setState({ job_detail: result });
              // var a = document.getElementById("description");
              // a.innerHTML = result.description
              console.log('result.result', result);
            }
            console.log('main-api', result);
            if (result.shifts) {
              result.shifts.map((val) => {
                this.state.shift_strings.push(val.start_string);
              });
            }
            var arr = this.state.shift_strings.filter(function (
              item,
              index,
              inputArray
            ) {
              return inputArray.indexOf(item) == index;
            });
            this.setState({ shift_strings: arr });
            console.log('state', this.state.shift_strings, arr);
            fetch(
              url +
                '/api/v1/user/submit-details/?email=' +
                encodeURIComponent(result.customer),
              {
                method: 'GET',
              }
            )
              .then((res) => res.json())
              .then((result) => {
                console.log('user', result);
                if (result.length > 0) {
                  this.setState({ user: result[0] });
                }
                console.log('alsjd', this.state.user.first_name);
              });
          }
        },
        (error) => {
          console.log('error', error);
        }
      );

    // this.get_wishlist_data();
    this.get_string_shift_data();
  }

  get_string_shift_data = () => {
    var id = this.props.match.params.id;
    if (localStorage.getItem('token')) {
      let auth = localStorage.getItem('token');

      fetch(url + '/jobs/job-shifts/?job_id=' + id, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth,
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            console.log('result', result);

            this.setState({ shift_select_timing: result });

            console.log('JOBDETAIL', result);
            let total = 0;
            result.map((details) => {
              //this.setState({ total_shift :  total_shift + Number(details.available) })
              total += Number(details.shift_available);
              this.setState({ total_shift: total });
            });
          },
          (error) => {
            console.log('error', error);
          }
        );
    } else {
      window.location.replace('/login');
    }
  };

  hideCalculator = () => {
    this.setState({ modal_show: false });
  };

  showCalculator = () => {
    this.setState({ modal_show: true });
  };

  render() {
    return (
      <JobDetailsView
        shifts={this.state.shift_strings}
        job_detail={this.state.job_detail}
        modal_show={this.state.modal_show}
        showCalculator={this.showCalculator}
        hideCalculator={this.hideCalculator}
        applyjob={this.applyjob}
        hideCustomModal={this.hideCustomModal}
        showCustomModal={this.showCustomModal}
        modal_show_custom={this.state.modal_show_custom}
        authResponse={this.state.authResponse}
        user={this.state.user}
        applied={this.state.applied}
        qualification={this.state.qualification}
        wishlist_data={this.state.wishlist_data}
        addToFavourites={this.addToFavourites}
        total_shift={this.state.total_shift}
        shift_select_timing={this.state.shift_select_timing}
        applied_shift_id={this.state.applied_shift_id}
        handelShift={this.handelShift}
        applyHideCustomModal={this.applyHideCustomModal}
        applyShowCustomModal={this.applyShowCustomModal}
        apply_modal_show={this.state.apply_modal_show}
        applyShowCustomModalFavorite={this.applyShowCustomModalFavorite}
        apply_job_check={this.state.apply_job_check}
        applyfavorite={this.applyfavorite}
        today_date={this.state.today_date}
        closing_job_date={this.state.closing_job_date}
      />
    );
  }
}

export default JobDetailsComponent;
